import React, { Component } from 'react';
import Modal from 'js/components/global/Modal';

class ErrorModalWrapper extends Component {
  state = {
    brandOptions: window._app.brandOptions,
  }

  render() {

    return (
      <Modal
        className="error-modal fok-title"
        contentLabel="Error Modal"
        onRequestClose={this.props.closeModal}
        isOpen
      >
        <h3 className="error-title">
          {this.props.title}
        </h3>
        <div className="error-content" data-testid="error-content">
          {this.props.children}
        </div>

      </Modal>
    );
  }
}

export default ErrorModalWrapper;



// WEBPACK FOOTER //
// ./js/components/global/ErrorModalWrapper.js